'use client';

import { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';

const FAQ_FORMATTERS = {
  p: (chunks) => <p>{chunks}</p>,
  strong: (chunks) => <strong className="font-semibold text-neutral-100">{chunks}</strong>,
  ul: (chunks) => <ul className="flex list-disc flex-col gap-2 pl-5">{chunks}</ul>,
  li: (chunks) => <li>{chunks}</li>,
};

export default function PricingFAQ({ className = '' }) {
  const t = useTranslations('PricingFAQ');
  const faqIds = Object.keys(t.raw('faqs'));
  const instanceId = useId();
  const [openFAQId, setOpenFAQId] = useState(null);

  return (
    <div className={className}>
      <h2 className="mb-8 text-center font-playfair text-3xl font-bold text-white">{t('title')}</h2>
      <div className="flex flex-col gap-3">
        {faqIds.map((id) => {
          const panelId = `${instanceId}-faq-${id}`;
          const isOpen = openFAQId === id;
          return (
            <div key={id} className="overflow-hidden rounded-lg border border-neutral-700 bg-neutral-800/50 transition-colors hover:border-neutral-600">
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenFAQId((previous) => previous === id ? null : id)}
                className="flex w-full items-start justify-between gap-4 p-6 text-left hover:bg-neutral-800/30"
              >
                <span className="flex-1 font-playfair font-semibold text-white">{t(`faqs.${id}.question`)}</span>
                <ChevronDown className={`h-5 w-5 flex-shrink-0 text-amber-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>
              <div id={panelId} hidden={!isOpen} className="px-6 pb-6">
                <div className="flex flex-col gap-3 text-sm leading-relaxed text-neutral-300">
                  {t.rich(`faqs.${id}.answer`, {
                    ...FAQ_FORMATTERS,
                    support: () => <a href={`mailto:${t('supportEmail')}`} className="text-amber-400 underline underline-offset-4 hover:text-amber-300">{t('supportEmail')}</a>,
                    refund: (chunks) => <Link href="/refund-policy" className="text-amber-400 underline underline-offset-4 hover:text-amber-300">{chunks}</Link>,
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
